var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkResolved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_13306)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99989 0.527344C13.6717 0.527344 17.4727 4.32812 17.4727 8.99996C17.4727 13.6717 13.6716 17.4725 8.99989 17.4725C4.32816 17.4725 0.527344 13.6717 0.527344 8.99996C0.527344 4.32819 4.32812 0.527344 8.99989 0.527344ZM7.87975 10.565L5.97688 8.66257C5.79038 8.4761 5.48828 8.4761 5.30181 8.66257C5.11562 8.84872 5.11569 9.15117 5.30181 9.33732L7.54249 11.578C7.7284 11.7639 8.03127 11.764 8.21718 11.578L12.6976 7.0971C12.8841 6.91059 12.8841 6.60878 12.6976 6.42227C12.5112 6.23584 12.2093 6.23587 12.0229 6.42227L7.87975 10.565Z",
    fill: "#537C5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_13306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkResolved);
export default __webpack_public_path__ + "static/media/check-mark_resolved.47a46463587319c16b10637566b5f042.svg";
export { ForwardRef as ReactComponent };